import React, { useEffect } from "react";

import { useBroadcastTokenSelector } from "../../../store";
import { ISocketService, setGlobalSocket, useGetSocket } from "../../../store/services";
import { SocketContext } from "./SocketContext";

export interface ISocketProviderProps {
  uri: string;
  children: React.ReactNode;
}

export const SocketProvider = ({ uri, children }: ISocketProviderProps): JSX.Element => {
  const broadcastToken: string = useBroadcastTokenSelector();
  const appKey: string = import.meta.env.REACT_APP_PUSHER_ID!;
  const socketService: ISocketService = useGetSocket(uri, appKey, broadcastToken);

  useEffect(() => {
    setGlobalSocket(socketService);
    return () => {
      setGlobalSocket(null);
    };
  }, [socketService]);

  return <SocketContext.Provider value={socketService}>{children}</SocketContext.Provider>;
};

SocketProvider.displayName = "SocketProvider";
